import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SupervisorQuickSaleForm from '../components/SupervisorQuickSaleForm';
import SupervisorDetailedSaleForm from '../components/SupervisorDetailedSaleForm';
import axios from 'axios';
import '../styles/Sales.css';

const SupervisorSales = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [saleType, setSaleType] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [supervisorInfo, setSupervisorInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  // Obtener información del supervisor al cargar el componente
  useEffect(() => {
    const fetchSupervisorInfo = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('/api/supervisors/info', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setSupervisorInfo(response.data);
      } catch (error) {
        console.error('Error al obtener información del supervisor:', error);
      } finally {
        setLoading(false);
      }
    };

    if (user && user.role === 'manager') {
      fetchSupervisorInfo();
    } else {
      setLoading(false);
    }
  }, [user]);

  const handleSaleTypeSelection = (type) => {
    setSaleType(type);
  };

  const handleSaleAdded = () => {
    // Mostrar mensaje de éxito
    setSuccessMessage('Venta registrada exitosamente');
    
    // Limpiar el mensaje después de 3 segundos
    setTimeout(() => {
      setSuccessMessage('');
      // Volver al tipo de selección
      setSaleType(null);
    }, 3000);
  };

  const handleCancel = () => {
    // Volver a la selección de tipo de venta
    setSaleType(null);
  };

  const handleBackToDashboard = () => {
    navigate('/supervisor-dashboard');
  };

  if (loading) {
    return (
      <div className="sales-container">
        <header className="sales-header">
          <h1>Registro de Ventas - Supervisor</h1>
          <button onClick={handleBackToDashboard} className="back-btn">
            Volver al Dashboard
          </button>
        </header>
        <div className="loading-container">
          <p>Cargando información del supervisor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sales-container">
      <header className="sales-header">
        <h1>Registro de Ventas - Supervisor</h1>
        <button onClick={handleBackToDashboard} className="back-btn">
          Volver al Dashboard
        </button>
      </header>

      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}

      {!saleType ? (
        <div className="sale-type-selection">
          <h2>Seleccione el tipo de venta</h2>
          <div className="sale-type-buttons">
            <button 
              className="sale-type-btn quick-sale-btn"
              onClick={() => handleSaleTypeSelection('quick')}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              <span>Venta Rápida</span>
              <p>Registre una venta con información mínima</p>
            </button>
            <button 
              className="sale-type-btn detailed-sale-btn"
              onClick={() => handleSaleTypeSelection('detailed')}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
              <span>Venta Detallada</span>
              <p>Registre una venta con productos, descuentos e impuestos</p>
            </button>
          </div>
        </div>
      ) : saleType === 'quick' ? (
        <SupervisorQuickSaleForm 
          onSaleAdded={handleSaleAdded}
          onCancel={handleCancel}
          supervisorInfo={supervisorInfo}
        />
      ) : saleType === 'detailed' ? (
        <SupervisorDetailedSaleForm 
          onSaleAdded={handleSaleAdded}
          onCancel={handleCancel}
        />
      ) : null}
    </div>
  );
};

export default SupervisorSales;
